import { formatAmount } from "@utils";
import { TagIcon } from "@heroicons/react/16/solid";

export const Summary = ({
  invoiceTotal,
  invoiceCount,
  creditNoteTotal,
  creditNoteCount,
  totalToPay,
  creditOnAccount,
  hasStatement,
  amountRequested,
  settlementDiscount = 0,
}) => {
  const displayTotal = Math.max(0, hasStatement ? totalToPay : amountRequested);
  const preDiscountTotal = settlementDiscount > 0 ? displayTotal + settlementDiscount : null;

  return (
    <>
      <div className="flex justify-between items-center mb-2 lg:mb-3 text-zinc-900 font-light text-sm">
        {hasStatement ? (
          <span className="text-zinc-600">
            {invoiceCount} {invoiceCount !== 1 ? "invoices" : "invoice"}
          </span>
        ) : (
          <span className="text-zinc-600">Amount</span>
        )}
        <span className="font-light">
          {formatAmount(hasStatement ? invoiceTotal : amountRequested)}
        </span>
      </div>

      {creditNoteCount > 0 && (
        <div className="flex justify-between items-center mb-2 lg:mb-3 text-zinc-900 text-sm font-light">
          <span className="text-zinc-600">
            {creditNoteCount}{" "}
            {creditNoteCount !== 1 ? "credit notes" : "credit note"}
          </span>
          <span className="text-green-700">
            {formatAmount(creditNoteTotal)}
          </span>
        </div>
      )}

      {creditOnAccount !== 0 && (
        <div className="flex justify-between items-center mb-2 lg:mb-3 text-sm font-light">
          <span className="text-zinc-600">Account credit</span>
          <span className="text-green-700">
            {formatAmount(creditOnAccount)}
          </span>
        </div>
      )}

      {settlementDiscount !== 0 && (
        <div className="flex justify-between items-center mb-2 lg:mb-3 text-sm font-light">
          <span className="text-zinc-600 flex items-center gap-1.5">
            <TagIcon className="size-3.5 shrink-0" />
            Settlement discount
          </span>
          <span className={settlementDiscount > 0 ? "text-green-700" : "text-zinc-600"}>
            {settlementDiscount > 0 ? "-" : "+"}{formatAmount(Math.abs(settlementDiscount))}
          </span>
        </div>
      )}

      <div className="flex justify-between items-center py-2.5 lg:py-4 font-normal border-t border-zinc-600">
        <span>You will pay</span>
        <span className="flex items-center gap-2">
          {formatAmount(displayTotal)}
          {preDiscountTotal !== null && (
            <span className="text-zinc-400 font-light line-through text-sm">
              {formatAmount(preDiscountTotal)}
            </span>
          )}
        </span>
      </div>
    </>
  );
};
